import { formatRp } from './invoiceUi';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'];

function formatDateId(d) {
  return `${String(d.getDate()).padStart(2, '0')} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

export function buildBankTransferSample(form) {
  const banks = (form.bank_accounts || []).filter(
    b => (b.bank_name || b.bank_account_number || b.bank_account_holder)
  );
  const notes = (form.manual_transfer_notes || '').trim();
  if (!banks.length && !notes) {
    return 'Pembayaran transfer bank:\nBank: BCA\nNo. Rekening: 1234567890\nAtas Nama: PT Contoh Sukses';
  }
  let out = 'Pembayaran transfer bank:';
  banks.forEach((a, i) => {
    if (banks.length > 1) out += `\n\nRekening ${i + 1}:`;
    if (a.bank_name) out += `\nBank: ${a.bank_name}`;
    if (a.bank_account_number) out += `\nNo. Rekening: ${a.bank_account_number}`;
    if (a.bank_account_holder) out += `\nAtas Nama: ${a.bank_account_holder}`;
  });
  if (notes) out += `\n\n${notes}`;
  return out.trim();
}

export function buildTemplateContext(form, defaults = {}) {
  const now = new Date();
  const due = new Date(now.getTime() + 7 * 86400000);
  const company = form.company_name || defaults.company || 'StarSender Store';
  return {
    '{customer_name}': 'Budi Santoso',
    '{customer_phone}': '6281234567890',
    '{customer_email}': 'budi@example.com',
    '{invoice_number}': 'INV-PREVIEW-001',
    '{issue_date}': formatDateId(now),
    '{due_date}': formatDateId(due),
    '{subtotal}': formatRp(1500000),
    '{total}': formatRp(1500000),
    '{public_url}': defaults.publicUrl || 'https://app.starsender.online/inv/preview',
    '{company_name}': company,
    '{company_address}': form.company_address || 'Jl. Contoh No. 123, Jakarta',
    '{company_phone}': form.company_phone || '021-1234567',
    '{bank_transfer_info}': buildBankTransferSample(form)
  };
}

export function applyInvoiceShortcodes(template, form, defaults) {
  if (!template) return '';
  const ctx = buildTemplateContext(form, defaults);
  let out = template;
  Object.keys(ctx).forEach(k => {
    out = out.split(k).join(ctx[k]);
  });
  return out;
}

/** WhatsApp-style: *bold* → HTML for preview only */
export function whatsAppTextToPreviewHtml(text) {
  const escaped = String(text || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  return escaped
    .replace(/\*([^*\n]+)\*/g, '<strong>$1</strong>')
    .replace(/\n/g, '<br>');
}

export const FALLBACK_SHORTCODES = [
  { code: '{customer_name}', label: 'Nama customer' },
  { code: '{customer_phone}', label: 'Telepon' },
  { code: '{customer_email}', label: 'Email' },
  { code: '{invoice_number}', label: 'No. invoice' },
  { code: '{issue_date}', label: 'Tanggal terbit' },
  { code: '{due_date}', label: 'Jatuh tempo' },
  { code: '{subtotal}', label: 'Subtotal' },
  { code: '{total}', label: 'Total' },
  { code: '{public_url}', label: 'Link invoice' },
  { code: '{company_name}', label: 'Nama brand' },
  { code: '{company_address}', label: 'Alamat' },
  { code: '{company_phone}', label: 'Telepon brand' },
  { code: '{bank_transfer_info}', label: 'Rekening bank' }
];

export const FALLBACK_DEFAULT_WA = `Halo {customer_name}! 👋

Berikut invoice *{invoice_number}* dari *{company_name}*.

💰 Total: *{total}*
📅 Jatuh tempo: {due_date}

🔗 Lihat & bayar online:
{public_url}

{bank_transfer_info}

Terima kasih 🙏`;

export const FALLBACK_DEFAULT_EMAIL_SUBJECT = 'Invoice {invoice_number} — {total} | {company_name}';

export const FALLBACK_DEFAULT_EMAIL_HTML = `<div style="margin:0;padding:0;background:#f4f6fb;font-family:Segoe UI,Roboto,Helvetica,Arial,sans-serif;">
  <table role="presentation" width="100%" cellspacing="0" cellpadding="0" style="background:#f4f6fb;padding:32px 16px;">
    <tr>
      <td align="center">
        <table role="presentation" width="100%" cellspacing="0" cellpadding="0" style="max-width:560px;background:#ffffff;border-radius:16px;overflow:hidden;box-shadow:0 8px 32px rgba(39,43,65,0.08);">
          <tr>
            <td style="background:linear-gradient(135deg,#5f63f2 0%,#4347d9 100%);padding:28px 32px;color:#ffffff;">
              <p style="margin:0 0 6px;font-size:13px;opacity:0.9;letter-spacing:0.04em;text-transform:uppercase;">Invoice</p>
              <h1 style="margin:0;font-size:22px;font-weight:700;line-height:1.3;">{company_name}</h1>
            </td>
          </tr>
          <tr>
            <td style="padding:32px;color:#272b41;font-size:15px;line-height:1.65;">
              <p style="margin:0 0 16px;">Halo <strong>{customer_name}</strong>,</p>
              <p style="margin:0 0 24px;">Terima kasih atas kepercayaan Anda. Berikut ringkasan tagihan <strong>{invoice_number}</strong>.</p>
              <table role="presentation" width="100%" cellspacing="0" cellpadding="0" style="background:#f8f9fc;border-radius:12px;margin-bottom:24px;">
                <tr>
                  <td style="padding:20px 24px;">
                    <p style="margin:0 0 8px;font-size:13px;color:#868eae;">Total tagihan</p>
                    <p style="margin:0;font-size:28px;font-weight:700;color:#5f63f2;">{total}</p>
                    <p style="margin:12px 0 0;font-size:13px;color:#868eae;">Jatuh tempo: <strong style="color:#272b41;">{due_date}</strong></p>
                  </td>
                </tr>
              </table>
              <p style="margin:0 0 20px;text-align:center;">
                <a href="{public_url}" style="display:inline-block;background:#5f63f2;color:#ffffff;text-decoration:none;font-weight:600;font-size:15px;padding:14px 28px;border-radius:10px;">Lihat invoice &amp; bayar</a>
              </p>
              <div style="font-size:14px;color:#5a5f7d;line-height:1.6;white-space:pre-line;">{bank_transfer_info}</div>
              <p style="margin:24px 0 0;font-size:13px;color:#868eae;">PDF invoice dilampirkan pada email ini.</p>
            </td>
          </tr>
          <tr>
            <td style="padding:20px 32px;background:#fafbff;border-top:1px solid #eef0f6;font-size:12px;color:#868eae;line-height:1.5;">
              {company_name}<br>
              {company_address}<br>
              {company_phone}
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</div>`;
